var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pane',{attrs:{"showRemarks":false,"bottom":0}},[_c('a-tabs',{attrs:{"tabBarStyle":{
        margin: '0',
      }},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"部门绩效"}}),_c('a-tab-pane',{key:"2",attrs:{"tab":"员工绩效"}})],1)],1),_c('a-card',{staticClass:"container"},[(_vm.active === '1')?_c('Dept'):_vm._e(),(_vm.active === '2')?_c('User'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }